export default {
  'Screenshot': 'لقطة الشاشة',
}